import React from 'react'
import PropTypes from 'prop-types'
import { useStateValue } from '../state'

export const NewExceptionBar = props => {
  const [currentState, dispatch] = useStateValue()

  return (
    <div
      className="card bg-default text-black w-75 p-2 rounded border mb-5"
      style={{ fontSize: '13pt' }}
    >
      <div
        className="d-flex justify-content-between vcenter pt-1"
        style={{ height: '32px' }}
      >
        {currentState.exceptionType === 'grantExtraTime' ? (
          <div>
            <span className="fas fa-hourglass fa-fw" />
            {currentState.override ? (
              '  Remove Time Limits'
            ) : (
              <ExtendTimeDisplay />
            )}
          </div>
        ) : (
          currentState.exceptionType === 'extendDueDate' && (
            <div>
              <span className="fas fa-plus fa-fw" />
              <span className="fas fa-calendar fa-fw" />
              {currentState.override ? (
                '  Remove Due Dates'
              ) : (
                <DueDateDisplay />
              )}
            </div>
          )
        )}
        <div>
          {props.displayRemoveButton && (
            <span
              onClick={() => {
                dispatch({ type: 'resetException' })
              }}
              className="fas fa-times fa-fw"
              style={{ cursor: 'pointer' }}
            />
          )}
        </div>
      </div>
    </div>
  )
}

NewExceptionBar.propTypes = {
  displayRemoveButton: PropTypes.bool.isRequired,
}

const ExtendTimeDisplay = () => {
  const [currentState] = useStateValue()
  return (
    <span>
      <span> Grant Extra Time: + </span>
      <span>
        <strong>{currentState.extraTime}</strong>
      </span>
      <span>{currentState.extraTime !== 1 ? ' Minutes' : ' Minute '}</span>
    </span>
  )
}

const DueDateDisplay = () => {
  const [currentState] = useStateValue()
  return (
    <span>
      <span> Extend Due Dates: + </span>
      <span>
        <strong>{currentState.shiftDays}</strong>
      </span>
      <span>{currentState.shiftDays !== 1 ? ' Days ' : ' Day '}</span>
      <span>
        <strong>{currentState.shiftHours}</strong>
      </span>
      <span>{currentState.shiftHours !== 1 ? ' Hours ' : ' Hour '}</span>
      <span>
        <strong>{currentState.shiftMinutes}</strong>
      </span>
      <span>{currentState.shiftMinutes !== 1 ? ' Minutes ' : ' Minute '}</span>
    </span>
  )
}
